import { CompanyApiClient } from "@/natsstubs/company/client";
import { SessionApiClient } from "@/natsstubs/session/client";
import { keysToSnake } from "@/natsstubs/wire/transform";

import type { NatsRpcBackend } from "../NatsRpcBackend";
import { errMessage } from "./errMessage";

export function registerCompanyAdapters(nats: NatsRpcBackend): void {
  const client = new CompanyApiClient(nats.caller);
  const sessionClient = new SessionApiClient(nats.caller);

  nats.register("root", "core", {
    // The session stub carries `editable`; camelToSnake yields the exact snake
    // session the editSession router guard reads (`session.editable`).
    get_session: async (args: unknown[]) =>
      keysToSnake((await sessionClient.getSession(String(args[0]))).session),

    get_sessions: async () =>
      ((await sessionClient.getSessions()).sessions ?? []).map((s) => ({
        session_id: s.id,
        name: s.name,
        archived: s.archived,
        editable: s.editable,
        creation_date: s.creationDate,
        planning_dates: s.planningDates ?? null,
        created_by: s.createdBy ?? null,
      })),

    get_users_see_all_sessions: async () => (await client.getUsersSeeAllSessions()).enabled,

    set_users_see_all_sessions: async (args: unknown[]) =>
      client.setUsersSeeAllSessions({ enabled: args[0] as boolean }),

    get_available_template_sessions: async () => (await client.getTemplateSessions()).templates,

    create_template_session: async (args: unknown[]) => {
      try {
        const res = await client.createTemplateSession({ template: String(args[0]) });
        return { success: true, new_teams: res.newTeams ?? [] };
      } catch (e) {
        return { success: false, error: errMessage(e) };
      }
    },
  });
}
